import type { DealFormDataWithTargeting } from '@openx/types/deal';

export const hasRboInState = (rootForm: DealFormDataWithTargeting | undefined): boolean => {
  return !!(rootForm?.rbo_config || rootForm?.__meta?.group_deal?.some(deal => !!deal?.rboConfig));
};
